/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import articleImage1 from '../../../assets/images/png/article1.png';
import articleImage2 from '../../../assets/images/png/article2.png';
import articleImage3 from '../../../assets/images/png/article3.png';
import articleImage4 from '../../../assets/images/png/more_in_health1.png';
import articleImage5 from '../../../assets/images/png/more_in_health2.png';
import articleImage6 from '../../../assets/images/png/more_in_health3.png';
import ArticleItemLists from '../../../Components/articleItemLists/ArticleItemLists';
import { SectionHeadingMed } from '../../../Components/Headings';
import './moreInHealth.css';

const articlesData = [
  {
    image: articleImage1,
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more'
  },
  {
    image: articleImage4,
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more'
  },
  {
    image: articleImage2,
    topic: 'A Letter from the Editor',
    topicDesc: '',
    btnText: 'read more'
  },
  {
    image: articleImage5,
    topic: 'A Letter from the Editor',
    topicDesc: '',
    btnText: 'read more'
  },
  {
    image: articleImage3,
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more'
  },
  {
    image: articleImage6,
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more'
  }
];

function MoreInHealth() {
  return (
    <section className="top_reads moreInHealth article">
      <Container>
        <SectionHeadingMed text="MORE IN HEALTH" />

        <Row>
          {articlesData.map((article, index) => {
            const { image, topic, topicDesc, btnText } = article;
            return (
              <Col md={6}>
                <ArticleItemLists
                  leftCol={4}
                  rightCol={7}
                  key={index}
                  image={image}
                  heading={topic}
                  desc={topicDesc}
                  btnText={btnText}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default MoreInHealth;
